import * as types from "../../action-types/category/mauPhieuThuCauHinhActionTypes";
import {
  IMauPhieuThuCauHinhReducer,
  INITIAL_MAU_PHIEU_THU_CAU_HINH,
} from "../../reducer-model/category/IMauPhieuThuCauHinhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

export const mauPhieuThuCauHinhReducer = (
  state: IMauPhieuThuCauHinhReducer = INITIAL_MAU_PHIEU_THU_CAU_HINH,
  action: any,
): IMauPhieuThuCauHinhReducer => {
  switch (action.type) {
    case types.MAU_PHIEU_THU_CAU_HINH_SELECT_ALL:
      return { ...state, status: eReducerStatusBase.is_loading };

    case types.MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_SUCCESS:
      const listData = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.data && Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
      return {
        ...state,
        list: listData,
        status: eReducerStatusBase.is_completed,
        error: null,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_ERROR:
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        error: action.payload,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID:
      return { ...state, status: eReducerStatusBase.is_loading };

    case types.MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID_SUCCESS:
      return {
        ...state,
        currentItem: action.payload,
        status: eReducerStatusBase.is_completed,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_INSERT:
      return { ...state, status: eReducerStatusBase.is_saving };

    case types.MAU_PHIEU_THU_CAU_HINH_INSERT_SUCCESS:
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        isShowEditModal: false,
        request: null,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_INSERT_ERROR:
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        error: action.payload,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_UPDATE:
      return { ...state, status: eReducerStatusBase.is_saving };

    case types.MAU_PHIEU_THU_CAU_HINH_UPDATE_SUCCESS:
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        isShowEditModal: false,
        request: null,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_UPDATE_ERROR:
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        error: action.payload,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_DELETE:
      return { ...state, status: eReducerStatusBase.is_deleting };

    case types.MAU_PHIEU_THU_CAU_HINH_DELETE_SUCCESS:
      return {
        ...state,
        list: state.list.filter((x) => x.id_mau_phieu_thu !== action.payload),
        status: eReducerStatusBase.is_deleted,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_DELETE_ERROR:
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        error: action.payload,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_SHOW_HIDE_EDIT_MODAL:
      return {
        ...state,
        isShowEditModal: action.payload.show,
        currentItem: action.payload.item || null,
        request: action.payload.item
          ? {
              ten_mau: action.payload.item.ten_mau,
              id_template_goc: action.payload.item.id_template_goc,
              kich_thuoc_giay: action.payload.item.kich_thuoc_giay,
              huong_giay: action.payload.item.huong_giay,
              margin_top: action.payload.item.margin_top,
              margin_bottom: action.payload.item.margin_bottom,
              margin_left: action.payload.item.margin_left,
              margin_right: action.payload.item.margin_right,
              font_family: action.payload.item.font_family,
              font_size: action.payload.item.font_size,
              cau_hinh_tru_cot: action.payload.item.cau_hinh_tru_cot,
              custom_css: action.payload.item.custom_css,
              is_active: action.payload.item.is_active,
            }
          : null,
      };

    case types.MAU_PHIEU_THU_CAU_HINH_RESET_REQUEST:
      return {
        ...state,
        request: null,
        currentItem: null,
      };

    default:
      return state;
  }
};
